import { addDays } from 'date-fns';

export const UPCOMING_SESSION_RANGE_OPTIONS = [
  { value: 'today', label: 'Today', sort: 0 },
  { value: 'next7Days', label: 'Next 7 days', sort: 1 },
  { value: 'next14Days', label: 'Next 14 days', sort: 2 },
  { value: 'next30Days', label: 'Next 30 days', sort: 3 },
];

export const getUpcomingSessionShortcuts = () => {
  const today = new Date();

  return [
    {
      label: 'Today',
      getValue: () => [today, today] as [Date, Date],
    },
    {
      label: 'Next 7 days',
      getValue: () => [today, addDays(today, 7)] as [Date, Date],
    },
    {
      label: 'Next 14 days',
      getValue: () => [today, addDays(today, 14)] as [Date, Date],
    },
    {
      label: 'Next 30 days',
      getValue: () => [today, addDays(today, 30)] as [Date, Date],
    },
  ];
};
